import { Pipe, PipeTransform } from '@angular/core';
import { Claims } from '@core/authentication/claims';
import { EnableForCountriesPipe } from './enable-for-countries-pipe';

@Pipe({
  name: 'disableForCountries'
})
export class DisableForCountriesPipe implements PipeTransform {
  constructor(private readonly enablePipe: EnableForCountriesPipe) {}

  transform<T>(
    countries: `${Claims.Country}` | `${Claims.Country}`[]
  ): boolean {
    return !this.enablePipe.transform(countries);
  }
}
